import { render, staticRenderFns } from "./SummarySavingsTables.vue?vue&type=template&id=06db0516&scoped=true&"
import script from "./SummarySavingsTables.vue?vue&type=script&lang=js&"
export * from "./SummarySavingsTables.vue?vue&type=script&lang=js&"
import style0 from "./SummarySavingsTables.vue?vue&type=style&index=0&id=06db0516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db0516",
  null
  
)

export default component.exports